import { scoreColor } from "@/lib/grades";

export function ScoreChip({ value, size = "md", testid }) {
  const dim = size === "lg" ? 48 : size === "sm" ? 26 : 34;
  const empty = value == null || isNaN(value);
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center justify-center rounded-full font-mono font-bold"
      style={{
        width: dim,
        height: dim,
        fontSize: size === "lg" ? 18 : size === "sm" ? 11 : 14,
        color: empty ? "hsl(var(--muted-foreground))" : "#fff",
        backgroundColor: empty ? "hsl(var(--muted))" : scoreColor(value),
      }}
    >
      {empty ? "–" : value}
    </span>
  );
}
